<div class="row">
  <div class="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3">
    <div id="search-address-section" class="address-search" >
      <div class="position-relative">
          <p-autoComplete [formControl]="addressSearch" (onSelect)="onAddressSelect($event.value)" field="properties.label"
            placeholder="Enter to search" [suggestions]="lookupService.filteredOptions" [showClear]="true" (onClear)="handleClearSearchedText()" [inputStyle]="{ paddingRight: '50px' }">
            <ng-template let-filteredOptions pTemplate="item">
              <div class="flex align-items-center">
                <div>{{ filteredOptions.properties.label }}</div>
              </div>
            </ng-template>
          </p-autoComplete>

          <i
              class="pi pi-search"
              role="button"
              tabindex="0"
              aria-label="Search"
             (click)="searchResult()"
             (keydown.enter)="searchResult($event)"
            ></i>
        </div>
      </div>
  </div>
</div>

<div class="row">
  <div class="col-md-4 col-12">
    <h4 class="title">Address Details</h4>
      <div class="address-table">
        <table aria-describedby="Table for Map Details" class="mapDetailsTable">
          <tr *ngFor="let row of tableData">
            <th class="header">{{ row.label }}:</th>
            <td>{{row.value}}</td>
          </tr>
        </table>
      </div>
  </div>
  <div class="col-md-8 col-12">
    <div id="map-view-container" class="map map-container" >
      <div id="address-map" [ngClass]="isLookup ? 'map-lookup' : 'map'"></div>
    </div>
  </div>
</div>